import React from 'react';

import FieldString from '../../../components/plain/FieldString';
import FieldReference from '../../../components/plain/FieldReference';
import FieldList_CardsPanel from '../../../components/plain/FieldList_CardsPanel';

import { CLASS_BOOK, CLASS_WORK } from '../../../util/consts/classes';
import { BOOK_PLAIN_PATH, WORK_PLAIN_PATH } from '../../../util/routes';
import { FORM_BOOK_TABLE, FORM_WORK_TABLE } from '../../../util/consts/forms';

class TabAAHonors extends React.Component {
	
	constructor(props) {
		super(props);
	}

	honorCardBuilder = (fieldHonor, index) => {
		let card = '';
		if( fieldHonor.value.year.value )
			card += fieldHonor.value.year.value  + ' ';
		if( fieldHonor.value.name.value )
			card += fieldHonor.value.name.value;
		return card;
	}
	buildHonorPanel = (fieldGroup, listItemInfo) => {
		let plain = this.props.plain;
		let instance = this.props.instance;
		let readOnly = this.props.readOnly;
		return (
			<HonorPanel fieldGroup={fieldGroup} listItemInfo={listItemInfo} 
				instance={instance} plain={plain} readOnly={readOnly}
			/>
		);
	}

	render() {
		let readOnly = this.props.readOnly;
		let plain = this.props.plain;
		let instance = this.props.instance;
		let parentField = this.props.parentField;
		if( ! parentField ) {
			parentField = instance.rootField;
		}
		return (
			<div style={{padding: '10px' }}>
				<FieldList_CardsPanel path={'/premium'} instance={instance} parentField={parentField} plain={plain} 
					buildItemComponent={this.buildHonorPanel} itemCardBuilder={this.honorCardBuilder} 
					labelEmptyToHeader={true} ignoreTitle={true} readOnly={readOnly}
					styles={{
						divMain: {
							padding: '10px 10px 10px 10px',
							backgroundColor: 'rgb(200,200,200)',
							border: '1px solid blue',
							marginTop: '10px',
							marginBottom: '10px'
						},
						divCardsBlock: {
							backgroundColor: 'rgb(200,200,200)',
							minWidth: '300px'
						},
						divCard: {
							marginTop: '3px',
							padding: '7px',
							cursor: 'pointer',
							backgroundColor: 'rgb(230,230,230)',
							minHeight: '18px'
						}
					}}
				/>
			</div>
		);
	}
}

class HonorPanel extends React.Component {

	/*
		plain
		instance
		fieldGroup
		listItemInfo
	*/
	constructor(props) {
		super(props);
	}

	render() {
		let fieldGroup = this.props.fieldGroup;
		let plain = this.props.plain;
		let instance = this.props.instance;
		let readOnly = this.props.readOnly;
		return (
			<div style={{flexGrow: '1', margin: '5px 0 0 0', padding: '10px', backgroundColor: 'rgb(240,240,240)'}}>
				<div style={{padding: '10px', border: '1px solid gray'}}>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldString instance={instance} path={'name'} parentField={fieldGroup} plain={plain}
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1'}}}
						 />
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldString instance={instance} path={'year'} parentField={fieldGroup} plain={plain}
							readOnly={readOnly}
							styles={{ input: {flexGrow: '0', width: "100px", marginRight: '15px'}}}
						 />
						<FieldString instance={instance} path={'nomination'} parentField={fieldGroup} plain={plain}
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1'}}}
						 />
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldString instance={instance} path={'honors'} parentField={fieldGroup} plain={plain}
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1'}}}
						 />
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldReference instance={instance} path={'bookRef'} parentField={fieldGroup} plain={plain} 
							readOnly={readOnly}
							styles={{ divMain: {flexGrow: '1'} }}
							refNodes={[
								{
									classId: CLASS_BOOK, plainFormPath: BOOK_PLAIN_PATH, 
									selectInstanceFormId: FORM_BOOK_TABLE,
									selectInstanceFormTitle: 'Книги'
								},
								{
									classId: CLASS_WORK, plainFormPath: WORK_PLAIN_PATH, 
									selectInstanceFormId: FORM_WORK_TABLE,
									selectInstanceFormTitle: 'Твори'
								}
							]}
						/>
					</div>
				</div>
			</div>
		)
	}
}

export default TabAAHonors;
